module.exports = __webpack_public_path__ + "b94dd076bdd102d7f2071da1f402b473.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FranklinGothic-Demi-webfont.ttf
// module id = 77
// module chunks = 0